// Mock data for Vannhi Ayurveda website

export const siteData = {
  brand: {
    name: "Vannhi Ayurveda",
    tagline: "Ignite the fire in you",
    logo: "https://customer-assets.emergentagent.com/job_vannhi-ayurveda/artifacts/oeipwsxb_Vannhi%20Logo%20Transparent.png"
  },
  navigation: [
    { name: "Services", href: "#services" },
    { name: "Our Doctors", href: "#doctors" },
    { name: "Packages", href: "#packages" },
    { name: "Blog", href: "#blog" },
    { name: "Contact", href: "#contact" }
  ],
  hero: {
    title: "Vannhi Ayurveda",
    subtitle: "IGNITE THE FIRE IN YOU",
    heading: "Holistic Healing Through Ancient Wisdom",
    description: "Discover a transformative journey to gut health and holistic well-being. VANNHI integrates the ancient sciences of Ayurveda and Yoga through a modern approach tailored for your lifestyle.",
    primaryCta: "Start Your Journey",
    secondaryCta: "Explore Services",
    image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1200&q=80&auto=format"
  },
  specializations: [
    "Irritable Bowel Syndrome (IBS)",
    "Acid Reflux (GERD)",
    "Chronic Bloating",
    "Indigestion",
    "Constipation",
    "Diarrhea"
  ],
  stats: [
    { value: "27+", label: "Years Combined Experience" },
    { value: "1000+", label: "Patients Healed" },
    { value: "2", label: "Expert Practitioners" }
  ],
  mission: {
    title: "Our Mission",
    description: "To revolutionize holistic wellness by integrating Ayurveda and Yoga, empowering individuals to achieve optimal gut health and overall well-being, fostering harmony between mind, body, and gut.",
    philosophy: {
      title: "The Vannhi Philosophy",
      content: "Ayurveda advocates that a strong gut is the foundation of total health. At VANNHI, through personalized guidance, effective solutions and modern accessibility,",
      highlight: "we help you reignite your inner fire."
    }
  },
  services: [
    {
      id: 1,
      category: "Ayurveda",
      title: "Personalized Ayurveda Consultations",
      description: "Certified Ayurveda doctors tailor treatment plans to your unique body constitution and gut concerns with comprehensive assessment and personalized care.",
      image: "https://images.pexels.com/photos/6187421/pexels-photo-6187421.jpeg?auto=compress&w=600&q=75",
      features: [
        "Individual constitution assessment",
        "Personalized treatment plans",
        "Herbal medicine recommendations",
        "Lifestyle & diet guidance"
      ],
      duration: "60 minutes",
      price: "₹1,800",
      originalPrice: "₹2,500",
      discount: "28% OFF"
    },
    {
      id: 2,
      category: "Yoga Therapy",
      title: "Therapeutic Yoga for Gut Health",
      description: "Specialized yoga sessions designed to enhance digestion and balance the gut-brain connection through targeted asanas, pranayama, and meditation.",
      image: "https://images.unsplash.com/photo-1582106316415-d02d4d0e9066?w=600&q=75&auto=format",
      features: [
        "Gut-specific yoga sequences",
        "Breathing techniques",
        "Digestive enhancement practices",
        "Stress management",
        "Mind-body balance"
      ],
      duration: "45 minutes",
      price: "₹1,500",
      originalPrice: "₹2,000",
      discount: "25% OFF"
    },
    {
      id: 3,
      category: "Integrated Program",
      title: "Integrated Gut Health Program",
      description: "Comprehensive approach combining Ayurveda and Yoga for powerful gut healing with personalized diet charts and lifestyle modifications.",
      image: "https://images.unsplash.com/photo-1554244933-d876deb6b2ff?w=600&q=75&auto=format",
      features: [
        "Ayurveda + Yoga integration",
        "Custom diet & lifestyle plans",
        "Ayurvedic supplements included",
        "Regular follow-ups",
        "Holistic healing approach"
      ],
      duration: "Package programs",
      price: "Starting ₹5,000/month",
      originalPrice: "₹7,000/month",
      discount: "29% OFF"
    }
  ],
  doctors: [
    {
      id: 2,
      name: "Dr. Deepa Nair",
      title: "Therapeutic Yoga Specialist",
      qualifications: "BAMS, MD(Yoga) • 12+ years Experience",
      image: "https://customer-assets.emergentagent.com/job_vannhi-ayurveda/artifacts/86yhoth4_dr._Deepa_Nair-.png",
      description: "A therapeutic yoga specialist with a strong Ayurvedic foundation, Dr. Deepa blends asanas, pranayama, meditation, and yogic detox practices to help clients manage lifestyle disorders and restore balance.",
      highlight: "Global consulting experience with work at leading wellness institutions",
      expertise: ["Therapeutic Yoga", "Lifestyle Disorders", "Yogic Detox Practices", "Ayurvedic Foundation", "+1 more"],
      languages: "English, Malayalam, Hindi",
      location: "AyurNidhi Ayurveda & Yoga Centre, Kerala and Goa"
    },
    {
      id: 3,
      name: "Dr. Neethu C. Mohan",
      title: "Ayurveda Specialist",
      qualifications: "BAMS, MD(Ay) • 14+ years Experience",
      image: "https://static.prod-images.emergentagent.com/jobs/5bb3223d-242b-497b-9c67-60934c8baaae/images/7ebc5b87c10e704e2b209b98a55cedc6fd37e71f74b35025f2450861d294d875.jpeg",
      description: "A distinguished Ayurveda specialist with over 14 years of clinical, academic, and editorial expertise, blends tradition with innovation to treat gastrointestinal, neurological, and lifestyle disorders. Renowned for her global health talks and research presentations, she is dedicated to integrating authentic Ayurveda with modern care, empowering patients and professionals through education, consultations, and content creation.",
      highlight: "Renowned for global health talks and research presentations",
      expertise: ["Gastrointestinal Disorders", "Neurological Conditions", "Lifestyle Disorders", "Authentic Ayurveda", "+1 more"],
      languages: "English, Malayalam, Hindi",
      location: "Vannhi Ayurveda, Kerala and Goa"
    }
  ],
  healingJourney: [
    { step: 1, title: "Book Your Consultation", description: "Schedule a personalized assessment with our expert doctors" },
    { step: 2, title: "Personalized Consultation", description: "Get Ayurveda & Yoga consultations tailored to your needs" },
    { step: 3, title: "Ayurvedic Supplements", description: "Receive prescribed supplements with free shipping" },
    { step: 4, title: "Regular Follow-ups", description: "Continuous monitoring and guidance for lasting results" }
  ],
  packages: [
    {
      id: 1,
      name: "1 Month Gut Health Package",
      price: "₹5,000",
      originalPrice: "₹7,000",
      savings: "Save ₹2,000",
      discount: "29% OFF",
      popular: false,
      features: [
        "2 clinical consultations",
        "Medicine supplements with shipping",
        "Customized diet and lifestyle guidelines",
        "1 yoga consultation"
      ]
    },
    {
      id: 2,
      name: "3 Month Complete Healing Package",
      price: "₹12,000",
      originalPrice: "₹18,000",
      savings: "Save ₹6,000",
      discount: "33% OFF",
      popular: true,
      features: [
        "6 clinical consultations",
        "Medicine supplements with shipping",
        "Customized diet and lifestyle guidelines as per condition",
        "3 yoga consultations",
        "Regular progress monitoring"
      ]
    }
  ],
  testimonials: [
    {
      id: 1,
      quote: "Dr. Neethu's integrated approach completely transformed my digestive issues. The combination of Ayurvedic medicines and therapeutic yoga has given me lasting relief from chronic bloating and IBS.",
      author: "Priya Sharma",
      location: "Mumbai",
      package: "3-Month Gut Health Package"
    }
  ],
  blogPosts: [
    {
      id: 1,
      category: "Ayurvedic Digestion",
      title: "Ignite Your Inner Fire: Ayurvedic Secrets for Better Digestion",
      excerpt: "Discover how Ayurveda's concept of 'Agni' (digestive fire) can transform your gut health and overall well-being naturally.",
      image: "https://images.unsplash.com/photo-1506368249639-73a05d6f6488?w=400&q=75&auto=format",
      author: "Dr. Neethu C. Mohan",
      date: "2025-01-15",
      readTime: "8 min read"
    },
    {
      id: 2,
      category: "Yoga Therapy",
      title: "Therapeutic Yoga for IBS: Ancient Practices for Modern Problems",
      excerpt: "Learn specific yoga sequences and breathing techniques that can naturally manage IBS symptoms and restore digestive balance.",
      image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=400&q=75&auto=format",
      author: "Dr. Deepa Nair",
      date: "2025-01-12",
      readTime: "6 min read"
    },
    {
      id: 3,
      category: "Holistic Health",
      title: "The Gut-Brain Connection: How Your Digestive Health Affects Your Mind",
      excerpt: "Understanding the intricate relationship between gut health and mental well-being through the lens of Ayurveda and modern science.",
      image: "https://images.unsplash.com/photo-1458501534264-7d326fa0ca04?w=400&q=75&auto=format",
      author: "Dr. Deepa Nair",
      date: "2025-01-10",
      readTime: "10 min read"
    }
  ],
  contact: {
    phones: ["+919895702324", "+918275066143"],
    email: "care@vannhiayurveda.in",
    address: "49/b-2, Alto- Dabolim, Goa- 403801",
    hours: {
      weekdays: "Mon-Fri: 9:00 AM - 7:00 PM",
      saturday: "Saturday: 9:00 AM - 5:00 PM",
      sunday: "Sunday: By Appointment Only"
    }
  },
  footer: {
    quickLinks: [
      { name: "Services", href: "#services" },
      { name: "Our Doctors", href: "#doctors" },
      { name: "Packages", href: "#packages" },
      { name: "Blog", href: "#blog" },
      { name: "Book Consultation", href: "#contact" }
    ],
    copyright: "© 2025 Vannhi Ayurveda. All rights reserved. | Ignite the fire in you."
  }
};
